import React from "react";
import PropTypes from "prop-types";

import {
  Q360ErrorState,
  Q360LoadingState,
} from "../UI/States";

export default function StudioAsyncState({
  loading = false,
  error = null,
  onRetry = null,
  loadingMessage = "Chargement du Studio…",
  loadingDescription,
  errorTitle = "Chargement impossible",
  errorDescription,
  retryLabel = "Réessayer",
  compact = false,
  className,
  children,
}) {
  if (error) {
    const fallbackMessage =
      typeof error === "string"
        ? error
        : error?.message || "Une erreur est survenue.";

    return (
      <Q360ErrorState
        message={fallbackMessage}
        title={errorTitle}
        description={errorDescription}
        actionLabel={onRetry ? retryLabel : undefined}
        onAction={onRetry || undefined}
        compact={compact}
        className={className}
      />
    );
  }

  if (loading) {
    return (
      <Q360LoadingState
        message={loadingMessage}
        description={loadingDescription}
        compact={compact}
        className={className}
      />
    );
  }

  return children;
}

StudioAsyncState.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.instanceOf(Error),
    PropTypes.object,
  ]),
  onRetry: PropTypes.func,
  loadingMessage: PropTypes.string,
  loadingDescription: PropTypes.string,
  errorTitle: PropTypes.string,
  errorDescription: PropTypes.string,
  retryLabel: PropTypes.string,
  compact: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};
